export const DEFAULT_PAYWALL_SOURCE = "direct";

const PAYWALL_SOURCE_MAX_CHARS = 80;
const PAYWALL_SOURCE_PATTERN = /^[a-z0-9][a-z0-9_-]*$/;

export function normalizePaywallSource(source?: string | null): string {
  const normalized = source?.trim().toLowerCase().slice(0, PAYWALL_SOURCE_MAX_CHARS) || "";
  return PAYWALL_SOURCE_PATTERN.test(normalized) ? normalized : DEFAULT_PAYWALL_SOURCE;
}

export function buildPaywallSourceProperties(source?: string | null): {
  source: string;
  paywall_source: string;
} {
  const paywallSource = normalizePaywallSource(source);
  return {
    source: paywallSource,
    paywall_source: paywallSource,
  };
}
